module.exports = __webpack_public_path__ + "img/16_82.cd0d823f.png";